import { useEffect, useState } from 'react';

import { COLUMN_SETTINGS_STORAGE_KEY, type ColumnSettings, readColumnSettings } from './columnSettings';

// Reads the persisted column settings and keeps them in sync when another
// same-origin document (the settings dialog iframe) updates localStorage.
export const useColumnSettings = (): ColumnSettings => {
    const [settings, setSettings] = useState<ColumnSettings>(readColumnSettings);

    useEffect(() => {
        const handleStorage = (event: StorageEvent) => {
            if (event.key === null || event.key === COLUMN_SETTINGS_STORAGE_KEY) {
                setSettings(readColumnSettings());
            }
        };

        window.addEventListener('storage', handleStorage);
        return () => window.removeEventListener('storage', handleStorage);
    }, []);

    return settings;
};
